import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/logo_myculture.png'
import _imports_1 from '@/assets/icons/white_arrow_right_24px.png'


const _withScopeId = n => (_pushScopeId("data-v-47b39a57"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "menu-container flex-center" }
const _hoisted_4 = { class: "menu-navbar-for-test" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  src: _imports_0,
  alt: "Happily logo",
  class: "company-logo-image",
  style: {"width":"18rem"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mock-menu-container" }, null, -1))
const _hoisted_8 = { class: "assessment-card-container on-top-mobile-screen" }
const _hoisted_9 = {
  key: 0,
  class: "assessment-content test-card mb-32"
}
const _hoisted_10 = { class: "mx-auto" }
const _hoisted_11 = { class: "card-title" }
const _hoisted_12 = { class: "grid-2-50 min-m-mt-22" }
const _hoisted_13 = { class: "mr-40 fs-16 max-m-mt-24" }
const _hoisted_14 = { class: "fw-700" }
const _hoisted_15 = { class: "fs-16 min-m-ml-40 max-m-mt-24" }
const _hoisted_16 = { class: "mb-30 fw-700" }
const _hoisted_17 = { class: "ul-style" }
const _hoisted_18 = { class: "max-m-mr-auto" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "icons_white_arrow_right_24px",
  class: "icon-24 ml-16 max-m-ml-auto icon-invert-color"
}, null, -1))
const _hoisted_20 = {
  key: 1,
  class: "card-question-padding box-card mb-32 bg-FFFFFF"
}
const _hoisted_21 = { class: "width-max-520" }
const _hoisted_22 = { class: "card-title" }
const _hoisted_23 = { class: "fs-16 mt-12" }
const _hoisted_24 = { class: "flex-mid" }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { key: 3 }
const _hoisted_27 = { key: 4 }
const _hoisted_28 = { key: 5 }
const _hoisted_29 = { key: 6 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_confirm_candidate = _resolveComponent("confirm-candidate")!
  const _component_values_and_traits = _resolveComponent("values-and-traits")!
  const _component_oaic_archetypes = _resolveComponent("oaic-archetypes")!
  const _component_acceptable_behaviors = _resolveComponent("acceptable-behaviors")!
  const _component_work_style_identifier = _resolveComponent("work-style-identifier")!
  const _component_human_skills = _resolveComponent("human-skills")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`${_ctx.lang == 'th' ? 'font-Kanit' : 'font-Lato'}`)
  }, [
    (_ctx.step == 'confirm_candidate')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_confirm_candidate, { onFinishConfirmCandidate: _ctx.finishConfirmCandidate }, null, 8, ["onFinishConfirmCandidate"])
        ]))
      : (_ctx.step == 'get_start')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_ctx.companyLogoUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.companyLogoUrl,
                      alt: "Happily logo",
                      class: "company-logo-image",
                      style: {"width":"18rem"}
                    }, null, 8, _hoisted_5))
                  : (_openBlock(), _createElementBlock("img", _hoisted_6))
              ])
            ]),
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              (_ctx.step == 'get_start')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.greeting), 1),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createTextVNode(_toDisplayString(_ctx.$t("assessmentTest.Thank_you_for_taking")) + " ", 1),
                          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.creator.companyName), 1),
                          _createTextVNode(_toDisplayString(_ctx.$t("main.Thank_you_for_taking_end")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("assessmentTest.A_few_things_you_should")), 1),
                          _createElementVNode("ul", _hoisted_17, [
                            _createElementVNode("li", null, _toDisplayString(_ctx.$t("assessmentTest.Plan_to_take")) + " " + _toDisplayString(_ctx.timeSection + _ctx.extratime) + " " + _toDisplayString(_ctx.$t("assessmentTest.minutes_to_complete_this")), 1),
                            _createElementVNode("li", null, _toDisplayString(_ctx.$t("assessmentTest.It_is_in_your_best_interest")), 1),
                            _createElementVNode("li", null, _toDisplayString(_ctx.$t("assessmentTest.There_is_no_right")), 1),
                            _createElementVNode("li", null, _toDisplayString(_ctx.$t("assessmentTest.If_you_re_unsure")), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.nextStepBTN())),
                      class: "min-m-mx-auto btn btn-50 btn-primary",
                      style: {"margin-top":"8rem"}
                    }, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("btn.Get_Started")), 1),
                      _hoisted_19
                    ])
                  ]))
                : (_ctx.step == 'complete')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("assessmentTest.You_ve_completed_all_section")), 1),
                        _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t(
                  "assessmentTest.Thank_you_for_taking_to_complete_the_assessment"
                )), 1),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", {
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.finishAssessment && _ctx.finishAssessment(...args))),
                            class: "mx-auto btn btn-50 btn-primary",
                            style: {"margin-top":"8rem"}
                          }, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("btn.Close")), 1)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
            ])
          ]))
        : (_ctx.step == 'values_and_traits')
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createVNode(_component_values_and_traits, {
                onFinishValueAndTraits: _ctx.reTurnValueAndTraits,
                lastSection: _ctx.lastSection,
                valuesAndTraits: _ctx.valuesAndTraits
              }, null, 8, ["onFinishValueAndTraits", "lastSection", "valuesAndTraits"])
            ]))
          : (_ctx.step == 'OAIC_archetypes')
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createVNode(_component_oaic_archetypes, {
                  onFinishValueAndTraits: _ctx.reTurnValueAndTraits,
                  lastSection: _ctx.lastSection
                }, null, 8, ["onFinishValueAndTraits", "lastSection"])
              ]))
            : (_ctx.step == 'acceptable_behaviors')
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createVNode(_component_acceptable_behaviors, {
                    onFinishValueAndTraits: _ctx.reTurnAcceptableBehaviors,
                    lastSection: _ctx.lastSection
                  }, null, 8, ["onFinishValueAndTraits", "lastSection"])
                ]))
              : (_ctx.step == 'work_style_identifier')
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createVNode(_component_work_style_identifier, {
                      onFinishValueAndTraits: _ctx.reTurnWorkStyleIdentifier,
                      lastSection: _ctx.lastSection
                    }, null, 8, ["onFinishValueAndTraits", "lastSection"])
                  ]))
                : (_ctx.step == 'human_skills')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createVNode(_component_human_skills, {
                        onFinishValueAndTraits: _ctx.reTurnHumanSkills,
                        lastSection: _ctx.lastSection
                      }, null, 8, ["onFinishValueAndTraits", "lastSection"])
                    ]))
                  : _createCommentVNode("", true)
  ], 2))
}